import { TableColumnsType } from 'antd';
import TableComponent from 'components/Table/TableComponent';
import usePagination from 'hooks/usePagination';
import Content from 'layouts/Content';
import { forwardRef, useImperativeHandle, useMemo } from 'react';
import { generateUUID } from 'utils/constants/functions';
import { HocChangePagination } from 'utils/HocChangePagination';

interface ITableCustomerRevenueProps {
  loading?: boolean;
  data: any;
  exportExcel?: (columns: any) => void;
}

const TableCustomerRevenue = (
  { data, loading, exportExcel }: ITableCustomerRevenueProps,
  ref: any,
) => {
  const { page, page_size } = usePagination();

  const columns: TableColumnsType = useMemo(
    () => [
      {
        width: 50,
        title: 'STT',
        align: 'center',
        render: (_: any, __: any, index: number) =>
          index + 1 + page_size * (page - 1),
      },
      {
        width: 250,
        title: 'Tên khách hàng',
        dataIndex: 'customer_name',
      },
      {
        width: 160,
        title: 'Mã khách hàng',
        dataIndex: 'sap_customer_id',
      },
      {
        width: 160,
        title: 'Mã khách hàng (Cha)',
        dataIndex: 'main_customer_id',
      },
      {
        width: 150,
        title: 'Tỉnh thành',
        dataIndex: 'city_name',
      },
      {
        title: 'Hàng công',
        children: [
          {
            width: 100,
            title: 'Hạng thẻ',
            dataIndex: 'rank_name',
            render: (text: string) => text || '-',
          },
          {
            type: 'number',
            width: 90,
            title: 'Tuổi vàng',
            dataIndex: 'process_age',
            align: 'right',
            render: (text: string) => text || '-',
          },
          {
            width: 90,
            title: 'Chủng loại',
            dataIndex: 'process_species',
            render: (text: string) => text || '-',
          },
          {
            width: 100,
            title: 'Mã sản phẩm',
            dataIndex: 'process_product_id',
            render: (text: string) => text || '-',
          },
          {
            type: 'number',
            width: 110,
            title: 'Số lượng mua',
            dataIndex: 'quantity_process',
            align: 'right',
            render: (text: string) => text || '-',
          },
          {
            type: 'number',
            width: 170,
            title: 'TB trọng lượng (Phân)',
            dataIndex: 'process_gold_with_of_stook',
            align: 'right',
            render: (text: number) => (text ? text.toFixed(3) : '-'),
          },
        ],
      },
      {
        title: 'Hàng món',
        children: [
          {
            width: 100,
            title: 'Hạng thẻ',
            dataIndex: 'rank_name',
            render: (text: string) => text || '-',
          },
          {
            type: 'number',
            width: 90,
            title: 'Tuổi vàng',
            dataIndex: 'product_age',
            align: 'right',
            render: (text: string) => text || '-',
          },
          {
            width: 90,
            title: 'Chủng loại',
            dataIndex: 'product_species',
            render: (text: string) => text || '-',
          },
          {
            width: 100,
            title: 'Mã sản phẩm',
            dataIndex: 'product_id',
            render: (text: string) => text || '-',
          },
          {
            type: 'number',
            width: 110,
            title: 'Số lượng mua',
            dataIndex: 'quantity_product',
            align: 'right',
            render: (text: string) => text || '-',
          },
          {
            type: 'number',
            width: 170,
            title: 'TB trọng lượng (Phân)',
            dataIndex: 'product_gold_with_of_stook',
            align: 'right',
            render: (text: number) => (text ? text.toFixed(3) : '-'),
          },
        ],
      },
    ],
    [page, page_size],
  );

  useImperativeHandle(ref, () => ({
    handleExportExcel,
  }));

  const handleExportExcel = () => {
    exportExcel && exportExcel(columns);
  };

  return (
    <Content>
      <TableComponent
        scroll={{ x: 'max-content' }}
        columns={columns}
        dataSource={data.items}
        rowKey={(record) => record?.id || generateUUID()}
        loading={loading}
        pagination={{
          current: data.pageInfo?.currentPage,
          pageSize: data.pageInfo?.itemsPerPage,
          total: data.pageInfo?.totalItems,
          onChange: HocChangePagination(),
        }}
      />
    </Content>
  );
};

export default forwardRef(TableCustomerRevenue);
